import React, { useEffect, useState } from 'react';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import Cancel from './../../../../assets/icons/close.png';
import itemImg from './../../../../assets/icons/menu.png';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import { ToastContainer, toast } from 'react-toastify'
import Typography from "@mui/material/Typography";
import AutoCompleteMultiSelect from "../../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import SchedulerDetailsTable from "../SchedulerView/SchedulerDetailsViewWithTable/SchedulerDetailsTable.tsx";

//import "./ArchiveDialog.css";

import axios from 'axios';

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

function EditSectionSchedulerDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] = useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const handleClose = () => {
    props.onClose();
    // setKeyword(null)
    // setSelectedValue(null);
    // setopenMenuCloseConfirmaitonModal(false);
    // setopenArchiveConfirmaitonModal(false);
    // setOpenDialog(false);
    // setRestaurantId([]);

  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const { open, onClose, dialogType, id, cancledRes, onToggleSwitch, selectedRestaurants, openDialog: toggle } = props;

  console.log("cancledRes", cancledRes)

  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const [schedulerDatas, setSchedulerDatas] = useState([]);

  const loadData = async () => {
    try {
      const response = await axios.get(`${apiAddress}/api/Schedule`);
      const temp = response.data.map((dt) => ({
        id: dt.scheduleId,
        title: dt.scheduleName,
        contentId: null,
      }));
      setSchedulerDatas(temp);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data || "Failed to load schedules", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const [sectionSelected, setsectionSelected] = useState([]);
  const [scheduleSelected, setscheduleSelected] = useState([]);

  const sectionAddedvalue = (props) => {
    if (props.length === 1) {
      // Allow only reducing schedules, no more additions
      setsectionSelected(props);
    }

    if (props.length === 0) {
      // Allow adding a schedule when no schedules exist
      setsectionSelected(props);
    }
  };
  //   const ScheduleAddedvalue = (props) => {
  //     setscheduleSelected(props);
  //     handleTempSchedulerAdd(props)

  //     if (props.length > 1) {
  //         toast.error("You can only select one schedule at a time.", {
  //             position: "top-right",
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //             theme: "colored",
  //         });
  //         return;
  //     }
  //     if (props.length === 1 || props.length === 0) {
  //         setscheduleSelected(props);
  //         handleTempSchedulerAdd(props)
  //     }
  //   };
  const ScheduleAddedvalue = (props) => {
    if (props.length > 1) {
      toast.error("You can only select one schedule at a time.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    if (props.length === 1) {
      // Allow only reducing schedules, no more additions
      setscheduleSelected(props);
      handleTempSchedulerAdd(props);
    }

    if (props.length === 0) {
      // Allow adding a schedule when no schedules exist
      setscheduleSelected(props);
      handleTempSchedulerAdd(props);
    }
  };
  useEffect(() => {

    if (sectionSelected.length > 0) {
      axios
        .get(
          apiAddress +
          `/api/Section/getSectionSchedulerInfo?sectionId=${sectionSelected[0]?.id}`
        )
        .then((response) => {
          var list = [];

          var obj = {
            id: response.data?.scheduleId,
            title: response.data?.scheduleName,
          };

          var schedule = schedulerDatas.find((x) => x?.id == obj?.id);
          list.push(schedule)
          if (list.length > 0) {
            setscheduleSelected(list)
            handleTempSchedulerAdd(list)
          } else {
            setscheduleSelected([])
          }
        })
    }
    else {
      setscheduleSelected([])
      handleTempSchedulerAdd([])
    }
  }, [sectionSelected]);
  const [addedSchedulers, setAddedSchedulers] = React.useState([]);
  const [conflictedSchedulers, setConflictedSchedulers] = React.useState([]);
  const [addedtempSchedulers, setaddedtempSchedulers] = React.useState([]);

  const handleTempSchedulerAdd = async (schedulerList) => {
    setaddedtempSchedulers([]);

    let ids = []

    schedulerList.map((dt, i) => {
      ids.push(dt.id);
    })

    await axios
      .post(apiAddress + "/api/Schedule/getschedulebyidlist", ids)
      .then(function (response) {
        console.log(response.data.schedulerDatas);
        setAddedSchedulers(response.data.schedulerDatas);
        setConflictedSchedulers(response.data.conflictedData);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.response.data, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  console.log("sectionSelected", sectionSelected)
  const onClickUpdate = async () => {
    if (sectionSelected.length > 0 && scheduleSelected.length > 0) {
      axios
        .post(apiAddress + '/api/Section/UpdateScheduleFromMenuOrSection?scheduleId=' + scheduleSelected[0].id + '&sectionId=' + sectionSelected[0].id + '&restaurantId=' + sectionSelected[0].linkedRestaurantId + '&contentId=' + 2
        )
        .then((response) => {
          console.log(response.data);
          toast.success("Schedule Updated for this section", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          //  props.onHandleAddItem()
          //  setopenMenuCloseConfirmaitonModal(false);
          //  setopenArchiveConfirmaitonModal(false);
          //  setOpenDialog(false);
          setscheduleSelected([])
          setsectionSelected([])
        });
    }
  }


  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth="md"
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={'Do you want to leave without saving?'}
            bodyText={'All changes made will be lost'}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />

          {/* <SweetAlertModal
            headerText={'Are you sure?'}
            bodyText={'All changes made will be lost'}
            open={openArchiveConfirmaitonModal}
            onyes={archiveSubmit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}    
          /> */}
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className='d-flex' style={{ gap: '8px' }}>
                  <div>
                    <img src={itemImg} style={{ width: '1.8rem' }} alt='' />
                  </div>

                  <span style={{ color: '#2a7fd4' }}>
                    GoTaste :- Edit Section Scheduler
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt='Close' style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={1.5}>
                  <Typography style={{ paddingTop: "2rem" }}>Section</Typography>
                </Grid>
                <Grid item xs={5} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a section"}
                    datas={cancledRes}
                    value={sectionAddedvalue}
                    val={sectionSelected || []}
                  />
                </Grid>
                <Grid item xs={.3} style={{ paddingTop: "1rem" }}></Grid>
                <Grid item xs={5} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a schedule"}
                    datas={schedulerDatas}
                    value={ScheduleAddedvalue}
                    val={scheduleSelected || []}
                  />
                </Grid>
              </Grid>
            </div>
            <Grid item xs={5} style={{ paddingTop: "1rem" }}>
              <div>
                {addedSchedulers?.length > 0 && (
                  <SchedulerDetailsTable
                    addedtempSchedulers={addedSchedulers}
                  />
                )}
              </div>
            </Grid>
            <div>
              <DialogActions>
                {sectionSelected?.length > 0 && scheduleSelected?.length > 0 && (
                  <Button
                    onClick={onClickUpdate}
                    color='error'
                  >
                    Update
                  </Button>
                )}

              </DialogActions>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenMenuCloseConfirmaitonModal(true)}
              color='primary'
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default EditSectionSchedulerDialog;